var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',_vm._g({staticClass:"commit-hash-chip",attrs:{"outlined":"","label":"","color":"accent","to":_vm.copyOnClick ? undefined : _vm.to},on:{"click":function($event){_vm.copyOnClick ? _vm.copyToClipboard(_vm.text) : undefined}}},_vm.on),[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }